import React, {useContext, useState} from 'react';
import Typography from '@mui/material/Typography';
import {Field, Form, Formik} from 'formik';
import {TextField} from 'formik-mui';
import {Button, InputAdornment} from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import {researchInitialValue} from './ResearchModel';
import ResearchList from './ResearchList';
import Box from '@mui/material/Box';
import {researchApi} from '../../../services/ResearchServices';
import {SNACKBAR_OPEN} from '../../../reducers';
import {DispatchContext} from '../../../store';
import PageWrapper from '../../../common/PageWrapper/PageWrapper';

export default function ResearchMaterials() {
  const dispatch = useContext(DispatchContext);
  const [initialValues, setInitialValues] = useState(researchInitialValue);

  const handleSubmit = (values) => {
    const researchValues = {
      site_url: values?.site_url,
      translations: {
        en: {
          title: values?.translations?.en?.title,
          description: values?.translations?.en?.description
        }
      }
    }

    researchApi('post', {...researchValues}).then(res => {
      window.location.reload();
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'Success'}
      });
    });
  }

  return (
    <PageWrapper>
      <Typography className={'museum-font'} sx={{mt: 5}}>Research Materials</Typography>
      <div className={'header-divider'}/>
      <Formik initialValues={initialValues}
              onSubmit={handleSubmit}>
        {({
            values,
            errors,
            isSubmitting,
            handleChange,
            handleBlur,
            ...formik
          }) => (
          <Form>
            <Field component={TextField} label={'Resource Title'} size={'small'}
                   name={'translations.en.title'}
                   InputLabelProps={{style: {fontSize: 13, color: '#7E7D7D'}}} sx={{mr: 1}}/>
            <Field component={TextField} label={'Enter site url'} size={'small'}
                   name={'site_url'}
                   InputProps={{
                     startAdornment: (
                       <InputAdornment position="start">
                         <LinkIcon/>
                       </InputAdornment>
                     ),
                   }}
                   InputLabelProps={{style: {fontSize: 13, color: '#7E7D7D'}}} sx={{mr: 1}}/>
            <Field component={TextField} label={'Description'} size={'small'}
                   name={'translations.en.description'} multiline minRows={1} maxRows={5}
                   InputProps={{style: {width: 250}}}
                   InputLabelProps={{style: {fontSize: 13, color: '#7E7D7D'}}} sx={{mr: 1}}/>
            <Button variant={'contained'} type={'submit'}>Add research material</Button>
          </Form>
        )}
      </Formik>
      <Box sx={{mt: 2}}>
        <ResearchList/>
      </Box>
    </PageWrapper>
  );
}